<!-- <div class="card">
  <div class="card-body">
    <div class="card-title">
      <div class="row align-item-center">
        <div class="col-md-2 mb-3">
          <span class="report-title">Reports</span>
        </div>
        <div class="col-md-10 text-end pointer-event-none opacity-25">
          <div class="row ps-relative">
            <div class="coming-soon-overlay">
              <span>Coming Soon...</span>
            </div>
            <div class=" pr-0 reports-datepicker-one">
              <div class="input-group mb-3">
                <div ngbDropdown class="input-group-text p-0 border-color-input">
                  <button class="btn datepicker-btn" id="periodDropDown" ngbDropdownToggle>
                    Last Month <i class="mdi mdi-menu-down d-none d-xl-inline-block"></i>
                  </button>
                  <div ngbDropdownMenu aria-labelledby="dropdownBasic1">
                    <button ngbDropdownItem>Action - 1</button>
                    <button ngbDropdownItem>Another Action</button>
                    <button ngbDropdownItem>Something else is here</button>
                  </div>
                </div>
                <div class="net-sale-daterange-picker form-group text-start form-control border-0 p-0">

                  <div class="datepickerwrap form-control" daterangepicker [options]="options"
                    (selected)="selectedDate($event)">
                    <img src="../../../../assets/images/dashboard-images/bx-calendar.png" class="picker-icon">
                    <span class="date-text"><span class="display-date">{{startDateDisplayFormatted}}</span> - <span
                        class="display-date">{{endDateDisplayFormatted}}</span></span>
                  </div>
                </div>
              </div>
            </div>
            <div class=" text-center px-0 reports-vs">
              <div class="vs mt-2">VS</div>
            </div>
            <div class=" pl-0 reports-datepicker-two">
              <div class="input-group mb-3">
                <div ngbDropdown class="input-group-text p-0 border-color-input">
                  <button class="btn datepicker-btn" id="periodDropDown" ngbDropdownToggle>
                    Last Month <i class="mdi mdi-menu-down d-none d-xl-inline-block"></i>
                  </button>
                  <div ngbDropdownMenu aria-labelledby="dropdownBasic1">
                    <button ngbDropdownItem>Action - 1</button>
                    <button ngbDropdownItem>Another Action</button>
                    <button ngbDropdownItem>Something else is here</button>
                  </div>
                </div>
                <div class="net-sale-daterange-picker form-group text-start form-control border-0 p-0">

                  <div class="datepickerwrap form-control" daterangepicker [options]="option2"
                    (selected)="selectedDate($event)">
                    <img src="../../../../assets/images/dashboard-images/bx-calendar.png" class="picker-icon">
                    <span class="date-text"><span class="display-date">{{prevStartDateDisplayFormatted}}</span> - <span
                        class="display-date">{{prevEndDateDisplayFormatted}}</span></span>
                  </div>
                </div>
              </div>
            </div>
            <div class=" reports-datepicker-days">
              <div class="btn-group" role="group" aria-label="Basic radio toggle button group">
                <input type="radio" class="btn-check" name="btnradio" id="btnradio1" autocomplete="off" checked>
                <label class="btn btn-outline-primary" for="btnradio1">Month</label>

                <input type="radio" class="btn-check" name="btnradio" id="btnradio2" autocomplete="off">
                <label class="btn btn-outline-primary" for="btnradio2">Week</label>

                <input type="radio" class="btn-check" name="btnradio" id="btnradio3" autocomplete="off">
                <label class="btn btn-outline-primary" for="btnradio3">Day</label>
              </div>
            </div>
            <div class=" reports-datepicker-setting">
              <button class="btn rounded-circle" id="chartSelect" height="30px" width="40px"><i
                  class='bx bx-cog'></i></button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="all-reports-section">
      <div class="row">
        <div class="col-lg-4">
          <div class="card report-card ps-relative">
            <div class="grapgh-loader" *ngIf="grossSaleLoader">
              <span class="loader"></span>
            </div>
            <div class="card-body pb-0">
              <div class="card-title mb-0">
                <div class="row">
                  <div class="col">
                    <span class="graph-title">Gross Sales</span><span><img class="vertical-align-top info-icon" src="../../../../assets/images/dashboard-images/Group 6.png" alt="group-icon"></span>
                  </div>
                  <div class="col">
                    <div class="comparision-one text-end">
                      <span class="indication-badge  ml-1"
                        [ngClass]="checkNegative(grossSaleDataTotal.percentage) ? 'red': 'green'">
                        {{checkNegative(grossSaleDataTotal.percentage) ? grossSaleDataTotal.percentage :
                        showPlusData(grossSaleDataTotal.percentage) }}%
                      </span> <span class="graph-data-one">{{currency}}
                        {{grossSaleDataTotal.value1 | number : '1.2-2'}}</span>
                      <div class="text-end graph-data-two">{{currency}}
                        {{grossSaleDataTotal.value2 | number : '1.2-2'}}</div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="report-graph">
                <apx-chart class="apex-charts" dir="ltr" [series]="grossSaleData.series" [chart]="grossSaleData.chart"
                  [dataLabels]="grossSaleData.dataLabels" [stroke]="grossSaleData.stroke"
                  [colors]="grossSaleData.colors" [xaxis]="grossSaleData.xaxis" [grid]="grossSaleData.grid"
                  [tooltip]="grossSaleData.tooltip" [plotOptions]="grossSaleData.plotOptions"
                  [fill]="grossSaleData.fill" [markers]="grossSaleData.markers" [legend]="grossSaleData.legend"
                  [yaxis]="grossSaleData.yaxis" [tooltip]="grossSaleData.tooltip"></apx-chart>
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-4">
          <div class="card report-card ps-relative">
            <div class="grapgh-loader" *ngIf="netSaleLoader">
              <span class="loader"></span>
            </div>
            <div class="card-body pb-0">
              <div class="card-title mb-0">
                <div class="row">
                  <div class="col">
                    <span class="graph-title">Net Sales</span><span><img class="vertical-align-top info-icon" src="../../../../assets/images/dashboard-images/Group 6.png" alt="group-icon"></span>
                  </div>
                  <div class="col">
                    <div class="comparision-one text-end">
                      <span class="indication-badge  ml-1"
                        [ngClass]="checkNegative(netSaleDataTotal.percentage) ? 'red': 'green'">
                        {{checkNegative(netSaleDataTotal.percentage) ? netSaleDataTotal.percentage :
                        showPlusData(netSaleDataTotal.percentage) }}%
                      </span> <span class="graph-data-one">{{currency}}
                        {{netSaleDataTotal.value1 | number : '1.2-2'}}</span>
                      <div class="text-end graph-data-two">{{currency}}
                        {{netSaleDataTotal.value2 | number : '1.2-2'}}</div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="report-graph">
                <apx-chart class="apex-charts" dir="ltr" [series]="netSaleData.series" [chart]="netSaleData.chart"
                  [dataLabels]="netSaleData.dataLabels" [stroke]="netSaleData.stroke" [colors]="netSaleData.colors"
                  [xaxis]="netSaleData.xaxis" [grid]="netSaleData.grid" [tooltip]="netSaleData.tooltip"
                  [plotOptions]="netSaleData.plotOptions" [fill]="netSaleData.fill" [markers]="netSaleData.markers"
                  [legend]="netSaleData.legend" [yaxis]="netSaleData.yaxis" [tooltip]="netSaleData.tooltip"></apx-chart>
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-4">
          <div class="card report-card ps-relative">
            <div class="grapgh-loader" *ngIf="totalSaleLoader">
              <span class="loader"></span>
            </div>
            <div class="card-body pb-0">
              <div class="card-title mb-0">
                <div class="row">
                  <div class="col">
                    <span class="graph-title">Total Orders</span><span><img class="vertical-align-top info-icon" src="../../../../assets/images/dashboard-images/Group 6.png" alt="group-icon"></span>
                  </div>
                  <div class="col">
                    <div class="comparision-one text-end">
                      <span class="indication-badge  ml-1"
                        [ngClass]="checkNegative(totalSaleDataTotal.percentage) ? 'red': 'green'">
                        {{checkNegative(totalSaleDataTotal.percentage) ? totalSaleDataTotal.percentage :
                        showPlusData(totalSaleDataTotal.percentage) }}%
                      </span> <span class="graph-data-one">
                        {{totalSaleDataTotal.value1 | number : '1.2-2'}}</span>
                      <div class="text-end graph-data-two">
                        {{totalSaleDataTotal.value2 | number : '1.2-2'}}</div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="report-graph">
                <apx-chart class="apex-charts" dir="ltr" [series]="totalSaleData.series" [chart]="totalSaleData.chart"
                  [dataLabels]="totalSaleData.dataLabels" [stroke]="totalSaleData.stroke"
                  [colors]="totalSaleData.colors" [xaxis]="totalSaleData.xaxis" [grid]="totalSaleData.grid"
                  [tooltip]="totalSaleData.tooltip" [plotOptions]="totalSaleData.plotOptions"
                  [fill]="totalSaleData.fill" [markers]="totalSaleData.markers" [legend]="totalSaleData.legend"
                  [yaxis]="totalSaleData.yaxis" [tooltip]="totalSaleData.tooltip"></apx-chart>
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-4">
          <div class="card report-card ps-relative">
            <div class="grapgh-loader" *ngIf="totalTransactionLoader">
              <span class="loader"></span>
            </div>
            <div class="card-body pb-0">
              <div class="card-title mb-0">
                <div class="row">
                  <div class="col">
                    <span class="graph-title">Total Transactions</span><span><img class="vertical-align-top info-icon" src="../../../../assets/images/dashboard-images/Group 6.png" alt="group-icon"></span>
                  </div>
                  <div class="col">
                    <div class="comparision-one text-end">
                      <span class="indication-badge  ml-1"
                        [ngClass]="checkNegative(totalTransactionDataTotal.percentage) ? 'red': 'green'">
                        {{checkNegative(totalTransactionDataTotal.percentage) ? totalTransactionDataTotal.percentage :
                        showPlusData(totalTransactionDataTotal.percentage) }}%
                      </span> <span class="graph-data-one">
                        {{totalTransactionDataTotal.value1 | number : '1.2-2'}}</span>
                      <div class="text-end graph-data-two">
                        {{totalTransactionDataTotal.value2 | number : '1.2-2'}}</div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="report-graph">
                <apx-chart class="apex-charts" dir="ltr" [series]="totalTransactionData.series"
                  [chart]="totalTransactionData.chart" [dataLabels]="totalTransactionData.dataLabels"
                  [stroke]="totalTransactionData.stroke" [colors]="totalTransactionData.colors"
                  [xaxis]="totalTransactionData.xaxis" [grid]="totalTransactionData.grid"
                  [tooltip]="totalTransactionData.tooltip" [plotOptions]="totalTransactionData.plotOptions"
                  [fill]="totalTransactionData.fill" [markers]="totalTransactionData.markers"
                  [legend]="totalTransactionData.legend" [yaxis]="totalTransactionData.yaxis"
                  [tooltip]="totalTransactionData.tooltip"></apx-chart>
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-4">
          <div class="card report-card ps-relative">
            <div class="grapgh-loader" *ngIf="totalRefundsLoader">
              <span class="loader"></span>
            </div>
            <div class="card-body pb-0">
              <div class="card-title mb-0">
                <div class="row">
                  <div class="col">
                    <span class="graph-title">Total Refunds</span><span><img class="vertical-align-top info-icon" src="../../../../assets/images/dashboard-images/Group 6.png" alt="group-icon"></span>
                  </div>
                  <div class="col">
                    <div class="comparision-one text-end">
                      <span class="indication-badge  ml-1"
                        [ngClass]="checkNegative(totalRefundsDataTotal.percentage) ? 'red': 'green'">
                        {{checkNegative(totalRefundsDataTotal.percentage) ? totalRefundsDataTotal.percentage :
                        showPlusData(totalRefundsDataTotal.percentage) }}%
                      </span> <span class="graph-data-one">{{currency}}
                        {{totalRefundsDataTotal.value1 | number : '1.2-2'}}</span>
                      <div class="text-end graph-data-two">{{currency}}
                        {{totalRefundsDataTotal.value2 | number : '1.2-2'}}</div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="report-graph">
                <apx-chart class="apex-charts" dir="ltr" [series]="totalRefundsData.series"
                  [chart]="totalRefundsData.chart" [dataLabels]="totalRefundsData.dataLabels"
                  [stroke]="totalRefundsData.stroke" [colors]="totalRefundsData.colors" [xaxis]="totalRefundsData.xaxis"
                  [grid]="totalRefundsData.grid" [tooltip]="totalRefundsData.tooltip"
                  [plotOptions]="totalRefundsData.plotOptions" [fill]="totalRefundsData.fill"
                  [markers]="totalRefundsData.markers" [legend]="totalRefundsData.legend"
                  [yaxis]="totalRefundsData.yaxis" [tooltip]="totalRefundsData.tooltip"></apx-chart>
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-4">
          <div class="card report-card ps-relative">
            <div class="grapgh-loader" *ngIf="totalDiscountLoader">
              <span class="loader"></span>
            </div>
            <div class="card-body pb-0">
              <div class="card-title mb-0">
                <div class="row">
                  <div class="col">
                    <span class="graph-title">Total Discounts</span><span><img class="vertical-align-top info-icon" src="../../../../assets/images/dashboard-images/Group 6.png" alt="group-icon"></span>
                  </div>
                  <div class="col">
                    <div class="comparision-one text-end">
                      <span class="indication-badge  ml-1"
                        [ngClass]="checkNegative(totalDiscountDataTotal.percentage) ? 'red': 'green'">
                        {{checkNegative(totalDiscountDataTotal.percentage) ? totalDiscountDataTotal.percentage :
                        showPlusData(totalDiscountDataTotal.percentage) }}%
                      </span> <span class="graph-data-one">{{currency}}
                        {{totalDiscountDataTotal.value1 | number : '1.2-2'}}</span>
                      <div class="text-end graph-data-two">{{currency}}
                        {{totalDiscountDataTotal.value2 | number : '1.2-2'}}</div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="report-graph">
                <apx-chart class="apex-charts" dir="ltr" [series]="totalDiscountData.series"
                  [chart]="totalDiscountData.chart" [dataLabels]="totalDiscountData.dataLabels"
                  [stroke]="totalDiscountData.stroke" [colors]="totalDiscountData.colors"
                  [xaxis]="totalDiscountData.xaxis" [grid]="totalDiscountData.grid"
                  [tooltip]="totalDiscountData.tooltip" [plotOptions]="totalDiscountData.plotOptions"
                  [fill]="totalDiscountData.fill" [markers]="totalDiscountData.markers"
                  [legend]="totalDiscountData.legend" [yaxis]="totalDiscountData.yaxis"
                  [tooltip]="totalDiscountData.tooltip"></apx-chart>
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-4">
          <div class="card report-card ps-relative">
            <div class="grapgh-loader" *ngIf="totalTaxesLoader">
              <span class="loader"></span>
            </div>
            <div class="card-body pb-0">
              <div class="card-title mb-0">
                <div class="row">
                  <div class="col">
                    <span class="graph-title">Total Taxes</span><span><img class="vertical-align-top info-icon" src="../../../../assets/images/dashboard-images/Group 6.png" alt="group-icon"></span>
                  </div>
                  <div class="col">
                    <div class="comparision-one text-end">
                      <span class="indication-badge  ml-1"
                        [ngClass]="checkNegative(totalTaxesDataTotal.percentage) ? 'red': 'green'">
                        {{checkNegative(totalTaxesDataTotal.percentage) ? totalTaxesDataTotal.percentage :
                        showPlusData(totalTaxesDataTotal.percentage) }}%
                      </span> <span class="graph-data-one">{{currency}}
                        {{totalTaxesDataTotal.value1 | number : '1.2-2'}}</span>
                      <div class="text-end graph-data-two">{{currency}}
                        {{totalTaxesDataTotal.value2 | number : '1.2-2'}}</div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="report-graph">
                <apx-chart class="apex-charts" dir="ltr" [series]="totalTaxesData.series" [chart]="totalTaxesData.chart"
                  [dataLabels]="totalTaxesData.dataLabels" [stroke]="totalTaxesData.stroke"
                  [colors]="totalTaxesData.colors" [xaxis]="totalTaxesData.xaxis" [grid]="totalTaxesData.grid"
                  [tooltip]="totalTaxesData.tooltip" [plotOptions]="totalTaxesData.plotOptions"
                  [fill]="totalTaxesData.fill" [markers]="totalTaxesData.markers" [legend]="totalTaxesData.legend"
                  [yaxis]="totalTaxesData.yaxis" [tooltip]="totalTaxesData.tooltip"></apx-chart>
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-4">
          <div class="card report-card ps-relative">
            <div class="grapgh-loader" *ngIf="totalTipsLoader">
              <span class="loader"></span>
            </div>
            <div class="card-body pb-0">
              <div class="card-title mb-0">
                <div class="row">
                  <div class="col">
                    <span class="graph-title">Total Tips</span><span><img class="vertical-align-top info-icon" src="../../../../assets/images/dashboard-images/Group 6.png" alt="group-icon"></span>
                  </div>
                  <div class="col">
                    <div class="comparision-one text-end">
                      <span class="indication-badge  ml-1"
                        [ngClass]="checkNegative(totalTipsDataTotal.percentage) ? 'red': 'green'">
                        {{checkNegative(totalTipsDataTotal.percentage) ? totalTipsDataTotal.percentage :
                        showPlusData(totalTipsDataTotal.percentage) }}%
                      </span> <span class="graph-data-one">{{currency}}
                        {{totalTipsDataTotal.value1 | number : '1.2-2'}}</span>
                      <div class="text-end graph-data-two">{{currency}}
                        {{totalTipsDataTotal.value2 | number : '1.2-2'}}</div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="report-graph">
                <apx-chart class="apex-charts" dir="ltr" [series]="totalTipsData.series" [chart]="totalTipsData.chart"
                  [dataLabels]="totalTipsData.dataLabels" [stroke]="totalTipsData.stroke"
                  [colors]="totalTipsData.colors" [xaxis]="totalTipsData.xaxis" [grid]="totalTipsData.grid"
                  [tooltip]="totalTipsData.tooltip" [plotOptions]="totalTipsData.plotOptions"
                  [fill]="totalTipsData.fill" [markers]="totalTipsData.markers" [legend]="totalTipsData.legend"
                  [yaxis]="totalTipsData.yaxis" [tooltip]="totalTipsData.tooltip"></apx-chart>
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-4">
          <div class="card report-card ps-relative">
            <div class="grapgh-loader" *ngIf="totalDeliveryTipsLoader">
              <span class="loader"></span>
            </div>
            <div class="card-body pb-0">
              <div class="card-title mb-0">
                <div class="row">
                  <div class="col">
                    <span class="graph-title">Total Delivery Tips</span><span><img class="vertical-align-top info-icon" src="../../../../assets/images/dashboard-images/Group 6.png" alt="group-icon"></span>
                  </div>
                  <div class="col">
                    <div class="comparision-one text-end">
                      <span class="indication-badge  ml-1"
                        [ngClass]="checkNegative(totalDeliveryTipsDataTotal.percentage) ? 'red': 'green'">
                        {{checkNegative(totalDeliveryTipsDataTotal.percentage) ? totalDeliveryTipsDataTotal.percentage :
                        showPlusData(totalDeliveryTipsDataTotal.percentage) }}%
                      </span> <span class="graph-data-one">{{currency}}
                        {{totalDeliveryTipsDataTotal.value1 | number : '1.2-2'}}</span>
                      <div class="text-end graph-data-two">{{currency}}
                        {{totalDeliveryTipsDataTotal.value2 | number : '1.2-2'}}</div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="report-graph">
                <apx-chart class="apex-charts" dir="ltr" [series]="totalDeliveryTipsData.series"
                  [chart]="totalDeliveryTipsData.chart" [dataLabels]="totalDeliveryTipsData.dataLabels"
                  [stroke]="totalDeliveryTipsData.stroke" [colors]="totalDeliveryTipsData.colors"
                  [xaxis]="totalDeliveryTipsData.xaxis" [grid]="totalDeliveryTipsData.grid"
                  [tooltip]="totalDeliveryTipsData.tooltip" [plotOptions]="totalDeliveryTipsData.plotOptions"
                  [fill]="totalDeliveryTipsData.fill" [markers]="totalDeliveryTipsData.markers"
                  [legend]="totalDeliveryTipsData.legend" [yaxis]="totalDeliveryTipsData.yaxis"
                  [tooltip]="totalDeliveryTipsData.tooltip"></apx-chart>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div> -->


<!-- BREAKDOWN REPORT -->
<div class="container " style="max-width: 100% !important;">
  <div class="row">
    <!-- <div class="col-12 col-md-6 col-lg-4 mt-4" style="padding-left: 0 !important;">
      <div class="card br-0 dashboard-main h-100">
        <div class="card-body report-RTL-overview p-0">
          <div class="row allchart-dashboard-RTL">
            <div class="container">
             <div>
              <h6 class="fw-600 mb-4 font-size-20">{{ "Marketings Recommendations" | translate | async }}</h6>
              <div class="image-container">
                <img src="assets/images/feature-page-image/sales/Sales-Cash-Drawers.svg" alt="Marketing Recommendations">
              </div>
             </div>
             <div *ngIf="allEventsList.length > 0">
              <div *ngFor="let event of allEventsList; let i = index" [hidden]="currentSlide !== i">
                <p class="fw-bold">{{ event.name }}</p>
                <p>{{ event.description }}</p>
                <button class="upgrade-btn" (click)="compaignManage(event)">Create offer →</button>
              </div>
              <div style="display: flex; justify-content: space-evenly;">
                <button class="arrow-btn control-btn" (click)="previousSlide()" [disabled]="currentSlide === 0">&#8249;</button>
                <button class="arrow-btn control-btn" (click)="nextSlide()" [disabled]="currentSlide === allEventsList.length - 1">&#8250;</button>
              </div>
            </div>
            <div *ngIf="allEventsList.length == 0">
              <p class="fw-bold">No recommendations available</p>
             </div>
            </div>
          </div>
        </div>
      </div>
    </div> -->

    <!-- <div class="col-12 col-md-6 col-lg-4 mt-4" style="padding: 0 !important;">
      <div class="card br-0 dashboard-main h-100">
        <div class="card-body report-RTL-overview p-0">
          <div class="row allchart-dashboard-RTL">
            <div class="container">
            <div>
              <h6 class="fw-600 mb-4 font-size-20">{{ "eatOS Online Ordering" | translate | async }}</h6>
              <div class="image-container">
                <img src="assets/images/feature-page-image/sales/Sales-Cash-Drawers.svg" alt="eatOS Online Ordering">
              </div>
            </div>
             <div>
              <p class="fw-bold">eatOS Online Ordering</p>
              <p>Restaurants can save up to $36K a year in commissions* by switching to eatOS Online Ordering.</p>
              <button class="upgrade-btn" (click)="onlineStore()">Upgrade now</button>
             </div>
            </div>
          </div>
        </div>
      </div>
    </div> -->

    <!-- <div class="col-12 mt-4" style="padding: 0 !important;">
      <div class="card br-0 dashboard-main row mx-0" style="margin-bottom: 20px">
        <div class="card-body report-RTL-overview p-0">
          <div class="row allchart-dashboard-RTL">
            <div class="container col">
              <h6 class="fw-600 mb-4 font-size-20">{{ "Referral Program" | translate | async }}</h6>
              <div class="image-container">
                <img src="assets/images/feature-page-image/sales/Referral-program.svg" alt="Marketing Recommendations">
              </div>
              <p class="fw-bold">eatOS Referral Rewards Program</p>
              <p>
                Join the eatOS Referral Rewards Program and start earning exciting benefits by sharing our innovative restaurant POS with your network today!
              </p>
              <button class="upgrade-btn" (click)="referral()">Learn how</button>
            </div>
          </div>
        </div>
      </div>
    </div> -->


    <div class="col-12 mt-4" style="padding-right: 0 !important;">
      <div *ngIf="breakdownData?.length > 0" class="card br-0 dashboard-main h-100">
        <div class="card-body report-RTL-overview p-0">
          <div class="row allchart-dashboard-RTL">
            <div class="container">
                <h5 class="fw-600 mb-4 font-size-20">{{ "Breakdown Report" | translate | async }}</h5>
           
              <div class="table-responsive report_table mb-4">
                <table class="w-100">
                  <thead>
                    <tr>
                      <th>Time</th>
                      <th class="text-center">Net Sales</th>
                      <th class="text-center">Labour Cost</th>
                      <th class="text-end">Labour %</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let item of paginatedData">
                      <td>{{ convertTime(item.key) }}</td>
                      <td class="text-center">{{ currency }}{{ item.netSales }}</td>
                      <td class="text-center">{{ currency }}{{ item.labourCost }}</td>
                      <td class="text-end">{{ item.laboutPercent }}</td>
                    </tr>
                  </tbody>
                </table>
                <!--  -->
                <!-- <div class="pagination d-flex justify-content-center align-items-center">
                  <button class="btn btn-secondary mx-2" (click)="previousPage()" [disabled]="breakdownCurrentPage === 1">&#8592;</button>
                  <div *ngFor="let page of totalPagesArray; let i = index" class="mx-1">
                    <span [class.active]="breakdownCurrentPage === i + 1">{{ i + 1 }}</span>
                  </div>
                  <button class="btn btn-secondary mx-2" (click)="nextPage()" [disabled]="breakdownCurrentPage === breakdownTotalPages">&#8594;</button>
                </div> -->
                <!--  -->
              </div>
              <nav aria-label="Breakdown report pagination">
                <ul class="pagination justify-content-center">
                  <li class="page-item" [class.disabled]="breakdownCurrentPage === 1">
                    <a class="page-link" href="javascript:void(0)" (click)="previousPage()" aria-label="Previous">
                      <span aria-hidden="true">&laquo;</span>
                    </a>
                  </li>
                  <li class="page-item" [class.active]="breakdownCurrentPage === page" *ngFor="let page of pageNumbers">
                    <a class="page-link" href="javascript:void(0)" (click)="goToPage(page)">{{ page }}</a>
                  </li>
                  <li class="page-item" [class.disabled]="breakdownCurrentPage === breakdownTotalPages">
                    <a class="page-link" href="javascript:void(0)" (click)="nextPage()" aria-label="Next">
                      <span aria-hidden="true">&raquo;</span>
                    </a>
                  </li>
                </ul>
              </nav>

            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>


<!-- BREAKDOWN REPORT -->


<div class="card br-0 dashboard-main mt-4" style="margin-bottom: 20px">
  <div class="card-body report-RTL-overview p-0">
    <div class="row justify-content-between">
      <div class="col-12 report-RTL-over-title">
        <div>
          <h5 class="fw-600 mb-4 font-size-20">{{ "Reports Overview" | translate | async }}</h5>
        </div>
      </div>
      <div class="col-12 d-flex justify-content-between seatting-btn">
        <div *ngIf="settings" class="d-flex justify-content-end w-100 dashboard-RTL-grosssales">
          <div class="me-3 mb-3" style="width: 250px">
            <div id="drop1" #drop1>
              <ng-multiselect-dropdown
                [placeholder]="'Choose...' | translate | async"
                [settings]="dropdownSettings"
                [data]="dropdownList"
                [(ngModel)]="selectedItems"
              >
              </ng-multiselect-dropdown>
            </div>
          </div>
          <div class="me-3">
            <button
              class="btn btn-secondary savebtn"
              (click)="saveReportSetting()"
            >
              {{ "Save" | translate | async }}
            </button>
          </div>
        </div>

        <div *ngIf="!settings" class="d-flex w-100 justify-content-between setting-RTL-dashboard">
          <div class="row d-flex justify-content-start align-items-baseline">
            <div class="col-auto">
              <div class="input-group mb-3 date-picker-group d-flex">
                <div
                  ngbDropdown
                  class="input-group-text p-0 border-color-input"
                >
                  <button
                    class="btn datepicker-btn"
                    id="periodDropDown"
                    ngbDropdownToggle
                  >
                    {{ selectDateoption | translate | async }} <i class="mdi mdi-menu-up up"></i
                    ><i class="mdi mdi-menu-down down"></i>
                  </button>
                  <div ngbDropdownMenu aria-labelledby="dropdownBasic1">
                    <ng-container *ngFor="let type of dateFilteroptions">
                      <button
                        ngbDropdownItem
                        [ngClass]="selectDateoption === type ? 'disabled' : ''"
                        [disabled]="selectDateoption === type || selectedItems.length === 0"
                        (click)="selectedDateOption(type)"
                      >
                        {{ type | translate | async }}
                      </button>
                    </ng-container>
                  </div>
                </div>
                <div
                  class="net-sale-daterange-picker form-group text-start form-control border-0 p-0"
                >
                  <div
                    class="datepickerwrap form-control"
                    daterangepicker
                    [options]="options"
                    (selected)="selectedDate($event)"
                    [ngClass]="
                      selectDateoption === 'Custom' ? '' : 'pointer-event-none'
                    "
                  >
                  <img
                      src="../../../../assets/images/dashboard-images/bx-calendar.png"
                      class="picker-icon"
                    />
                    <span class="date-text"
                      ><span class="display-date">{{
                        startDateDisplayFormatted | translate | async
                      }}</span>
                      -
                      <span class="display-date">{{
                        endDateDisplayFormatted | translate | async
                      }}</span></span
                    >
                  </div>
                </div>
              </div>
            </div>

            <div class="col-auto f-12 fw-700 m-0">
              <p>{{ "VS" | translate | async }}</p>
            </div>
            <div class="col-auto">
              <div
                class="input-group mb-3 date-picker-group d-flex pointer-event-none"
              >
                <div
                  ngbDropdown
                  class="input-group-text p-0 border-color-input"
                >
                  <button
                    class="btn datepicker-btn"
                    id="periodDropDown"
                    ngbDropdownToggle
                  >
                    <span class="text-capitalize">{{
                      prevSelectDateoption | translate | async
                    }}</span>
                    <i class="mdi mdi-menu-up up"></i
                    ><i class="mdi mdi-menu-down down"></i>
                  </button>
                  <div ngbDropdownMenu aria-labelledby="dropdownBasic1">
                    <ng-container *ngFor="let type of dateFilteroptions">
                      <button
                        ngbDropdownItem
                        [ngClass]="selectDateoption === type ? 'disabled' : ''"
                        [disabled]="selectDateoption === type"
                        (click)="selectedDateOption(type)"
                      >
                        {{ type | translate | async }}
                      </button>
                    </ng-container>
                  </div>
                </div>
                <div
                  class="net-sale-daterange-picker form-group text-start form-control border-0 p-0"
                >
                  <div
                    class="datepickerwrap form-control"
                    daterangepicker
                    [options]="options"
                    (selected)="selectedDate($event)"
                  >
                  <img
                    src="../../../../assets/images/dashboard-images/bx-calendar.png"
                    class="picker-icon"
                  />
                    <span class="date-text"
                      ><span class="display-date">{{
                        prevStartDateDisplayFormatted | translate | async
                      }}</span>
                      -
                      <span class="display-date">{{
                        prevEndDateDisplayFormatted | translate | async
                      }}</span></span
                    >
                  </div>
                </div>
              </div>
            </div>

            <div
              class="btn-group col-md-1"
              role="group"
              aria-label="Basic radio toggle button group"
            >
              <!-- <ng-container *ngIf="daysDiffrence >= 365">
                <input
                  type="radio"
                  class="btn-check"
                  [disabled]="selectedItems.length === 0"
                  (click)="selectInterval('year')"
                  name="btnradiod1"
                  id="btnradio1"
                  autocomplete="off"
                  checked
                />
                <label
                  class="btn btn-outline-secondary h-36px fw-600"
                  for="btnradio1"
                  style="font-size: 12px; padding-top: 10px"
                  >{{ "Year1" | translate | async }}</label
                >
                <input
                  type="radio"
                  class="btn-check"
                  [disabled]="selectedItems.length === 0"
                  (click)="selectInterval('month')"
                  name="btnradiod1"
                  id="btnradio2"
                  autocomplete="off"
                />
                <label
                  class="btn btn-outline-secondary h-36px fw-600"
                  for="btnradio2"
                  style="font-size: 12px; padding-top: 10px"
                  >{{ "Month3" | translate | async }}</label
                >
              </ng-container> -->

              <ng-container *ngIf="daysDiffrence >= 365">
                <input
                  type="radio"
                  class="btn-check"
                  [disabled]="selectedInterval === 'year' || selectedItems.length === 0"
                  (click)="selectInterval('year')"
                  name="btnradiod1"
                  id="btnradio1"
                  autocomplete="off"
                  [checked]="selectedInterval === 'year'"
                />
                <label
                  class="btn btn-outline-secondary h-36px fw-600"
                  for="btnradio1"
                  style="font-size: 12px; padding-top: 10px"
                >
                  {{ 'Year' | translate | async }}
                </label>

                <input
                  type="radio"
                  class="btn-check"
                  [disabled]="selectedInterval === 'month' || selectedItems.length === 0"
                  (click)="selectInterval('month')"
                  name="btnradiod1"
                  id="btnradio2"
                  autocomplete="off"
                  [checked]="selectedInterval === 'month'"
                />
                <label
                  class="btn btn-outline-secondary h-36px fw-600"
                  for="btnradio2"
                  style="font-size: 12px; padding-top: 10px"
                >
                  {{ 'Month' | translate | async }}
                </label>
              </ng-container>

              <ng-container *ngIf="daysDiffrence > 90 && daysDiffrence < 365">
                <!-- [disabled]="selectedItems.length === 0" -->
                <div style="cursor: not-allowed;" title="The current reports are already in Month interval.">
                <input
                  type="radio"
                  class="btn-check"
                  name="btnradiod2"
                  (click)="selectInterval('month')"
                  [disabled]="true"
                  id="btnradio3"
                  autocomplete="off"
                  checked
                />
                <label
                  class="btn btn-outline-secondary h-36px fw-600"
                  for="btnradio3"
                  style="font-size: 12px; padding-top: 10px"
                  >{{ "Month" | translate | async }}</label
                >
                <!-- <input type="radio" class="btn-check" name="btnradiod2" (click)="selectInterval('week')" id="btnradio4"
                  autocomplete="off">
                <label class="btn btn-outline-secondary h-36px" for="btnradio4"
                  style="font-size: 12px; padding-top: 10px;">Week</label> -->
              </div>
              </ng-container>
              <!-- <ng-container *ngIf="daysDiffrence >= 60 && daysDiffrence < 90">
                <input
                  type="radio"
                  class="btn-check"
                  name="btnradiod3"
                  [disabled]="selectedItems.length === 0"
                  (click)="selectInterval('month')"
                  id="btnradio5"
                  autocomplete="off"
                  checked
                />
                <label
                  class="btn btn-outline-secondary h-36px fw-600"
                  for="btnradio5"
                  style="font-size: 12px; padding-top: 10px"
                  >{{ "Month1" | translate | async }}</label
                > -->
                <!-- <input type="radio" class="btn-check" name="btnradiod3" (click)="selectInterval('week')" id="btnradio6"
                  autocomplete="off">
                  <label class="btn btn-outline-secondary h-36px" for="btnradio6"
                  style="font-size: 12px; padding-top: 10px;">Week</label> -->
                <!-- <input
                  type="radio"
                  class="btn-check"
                  name="btnradiod3"
                  [disabled]="selectedItems.length === 0"
                  (click)="selectInterval('day')"
                  id="btnradio7"
                  autocomplete="off"
                />
                <label
                  class="btn btn-outline-secondary h-36px fw-600"
                  for="btnradio7"
                  style="font-size: 12px; padding-top: 8px"
                  >{{ "Day1" | translate | async }}</label
                >
              </ng-container> -->

              <ng-container *ngIf="daysDiffrence >= 60 && daysDiffrence < 90">
                <!-- Month Radio Button -->
                <input
                  type="radio"
                  class="btn-check"
                  name="btnradiod3"
                  [disabled]="selectedIntervalMonth === 'month' || selectedItems.length === 0"
                  (click)="selectInterval('month')"
                  id="btnradio5"
                  autocomplete="off"
                  [checked]="selectedIntervalMonth === 'month'"
                />
                <label
                  class="btn btn-outline-secondary h-36px fw-600"
                  for="btnradio5"

                >
                  {{ "Month" | translate | async }}
                </label>

                <!-- Day Radio Button -->
                <input
                  type="radio"
                  class="btn-check"
                  name="btnradiod3"
                  [disabled]="selectedIntervalMonth === 'day' || selectedItems.length === 0"
                  (click)="selectInterval('day')"
                  id="btnradio7"
                  autocomplete="off"
                  [checked]="selectedIntervalMonth === 'day'"
                />
                <label
                  class="btn btn-outline-secondary h-36px fw-600"
                  for="btnradio7"

                >
                  {{ "Day" | translate | async }}
                </label>
              </ng-container>
              <ng-container *ngIf="daysDiffrence > 14 && daysDiffrence < 60" >
                <div style="cursor: not-allowed;" title="The current reports are already in Day interval.">
                <!-- <input type="radio" class="btn-check" name="btnradiod4" id="btnradio8" (click)="selectInterval('week')"
                  autocomplete="off" >
                <label class="btn btn-outline-secondary h-36px" for="btnradio8"
                  style="font-size: 12px; padding-top: 10px;">Week</label> -->
                  <!-- [disabled]="selectedItems.length === 0" -->
                <input
                  type="radio"
                  class="btn-check"
                  name="btnradiod4"
                  id="btnradio9"
                  (click)="selectInterval('day')"
                  [disabled]="true"
                  autocomplete="off"
                  checked
                />
                <label
                  class="btn btn-outline-secondary h-36px fw-600"
                  for="btnradio9"
                  style="font-size: 12px; padding-top: 10px"
                  >{{ "Day" | translate | async }}</label
                >
              </div>
              </ng-container>
              <ng-container *ngIf="daysDiffrence <= 14 && daysDiffrence > 1">
                <!-- Day Radio Button -->
                <input
                  type="radio"
                  class="btn-check"
                  name="btnradiod5"
                  id="btnradio10"
                  [disabled]="selectedIntervalday === 'day' || selectedItems.length === 0"
                  (click)="selectInterval('day')"
                  autocomplete="off"
                  [checked]="selectedIntervalday === 'day'"
                />
                <label
                  class="btn btn-outline-secondary h-36px fw-600"
                  for="btnradio10"

                >
                  {{ "Day" | translate | async }}
                </label>

                <!-- Hour Radio Button -->
                <input
                  type="radio"
                  class="btn-check"
                  name="btnradiod5"
                  id="btnradio11"
                  [disabled]="selectedIntervalday === 'hour' || selectedItems.length === 0"
                  (click)="selectInterval('hour')"
                  autocomplete="off"
                  [checked]="selectedIntervalday === 'hour'"
                />
                <label
                  class="btn btn-outline-secondary h-36px fw-600"
                  for="btnradio11"
                >
                  {{ "Hour" | translate | async }}
                </label>
              </ng-container>
              <!-- <ng-container *ngIf="daysDiffrence <= 14 && daysDiffrence > 1">
                <input
                  type="radio"
                  class="btn-check"
                  name="btnradiod5"
                  id="btnradio10"
                  [disabled]="selectedItems.length === 0"
                  (click)="selectInterval('day')"
                  autocomplete="off"
                  checked
                />
                <label
                  class="btn btn-outline-secondary h-36px fw-600"
                  for="btnradio10"
                  style="font-size: 12px; padding-top: 10px"
                  >{{ "Day2" | translate | async }}</label
                >
                <input
                  type="radio"
                  class="btn-check"
                  name="btnradiod5"
                  id="btnradio11"
                  [disabled]="selectedItems.length === 0"
                  (click)="selectInterval('hour')"
                  autocomplete="off"
                />
                <label
                  class="btn btn-outline-secondary h-36px fw-600"
                  for="btnradio11"
                  style="font-size: 12px; padding-top: 10px"
                  >{{ "Hour2" | translate | async }}</label
                >
              </ng-container> -->
              <ng-container *ngIf="daysDiffrence == 0 || daysDiffrence <= 1">
                <!-- [disabled]="selectedItems.length === 0" -->

                <div style="cursor: not-allowed;" title="The current reports are already in Hour interval.">
                <input
                  type="radio"
                  class="btn-check"
                  name="btnradiod6"
                  (click)="selectInterval('hour')"
                  [disabled]="true"
                  id="btnradio12"
                  autocomplete="off"
                  checked
                />
                <label
                  class="btn btn-outline-secondary h-36px fw-600"
                  for="btnradio12"
                  style="font-size: 12px; padding-top: 10px"
                  >{{ "Hour" | translate | async }}</label
                >
              </div>
              </ng-container>
            </div>
          </div>
        </div>
        <div>
          <ng-container *ngIf="storeIdFixed === '*'">
            <button
              class="settings-icon cursor-pointer"
              (click)="handleSettings()"
              accessControl
              module="DashboardReport"
              access="3"
              style="border:none"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="icon icon-tabler icon-tabler-settings"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                stroke-width="2"
                stroke="currentColor"
                fill="none"
                stroke-linecap="round"
                stroke-linejoin="round"
              >
                <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                <path
                  d="M10.325 4.317c.426 -1.756 2.924 -1.756 3.35 0a1.724 1.724 0 0 0 2.573 1.066c1.543 -.94 3.31 .826 2.37 2.37a1.724 1.724 0 0 0 1.065 2.572c1.756 .426 1.756 2.924 0 3.35a1.724 1.724 0 0 0 -1.066 2.573c.94 1.543 -.826 3.31 -2.37 2.37a1.724 1.724 0 0 0 -2.572 1.065c-.426 1.756 -2.924 1.756 -3.35 0a1.724 1.724 0 0 0 -2.573 -1.066c-1.543 .94 -3.31 -.826 -2.37 -2.37a1.724 1.724 0 0 0 -1.065 -2.572c-1.756 -.426 -1.756 -2.924 0 -3.35a1.724 1.724 0 0 0 1.066 -2.573c-.94 -1.543 .826 -3.31 2.37 -2.37c1 .608 2.296 .07 2.572 -1.065z"
                ></path>
                <circle cx="12" cy="12" r="3"></circle>
              </svg>
            </button>
          </ng-container>
          <ng-container *ngIf="storeIdFixed !== '*'">
            <button class="settings-icon" (click)="handleSettings()" style="border:none"
              accessControl
              module="DashboardReport"
              access="3"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="icon icon-tabler icon-tabler-settings"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                stroke-width="2"
                stroke="currentColor"
                fill="none"
                stroke-linecap="round"
                stroke-linejoin="round"
              >
                <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                <path
                  d="M10.325 4.317c.426 -1.756 2.924 -1.756 3.35 0a1.724 1.724 0 0 0 2.573 1.066c1.543 -.94 3.31 .826 2.37 2.37a1.724 1.724 0 0 0 1.065 2.572c1.756 .426 1.756 2.924 0 3.35a1.724 1.724 0 0 0 -1.066 2.573c.94 1.543 -.826 3.31 -2.37 2.37a1.724 1.724 0 0 0 -2.572 1.065c-.426 1.756 -2.924 1.756 -3.35 0a1.724 1.724 0 0 0 -2.573 -1.066c-1.543 .94 -3.31 -.826 -2.37 -2.37a1.724 1.724 0 0 0 -1.065 -2.572c-1.756 -.426 -1.756 -2.924 0 -3.35a1.724 1.724 0 0 0 1.066 -2.573c-.94 -1.543 .826 -3.31 2.37 -2.37c1 .608 2.296 .07 2.572 -1.065z"
                ></path>
                <circle cx="12" cy="12" r="3"></circle>
              </svg>
            </button>
          </ng-container>
        </div>
      </div>
    </div>
    <div class="row p-4">
      <!-- <ng-container *ngFor="let report of dropdownList; index as i;">
        <div class="col-md-4">
          <div class="charts-box ps-relative">
            <div class="grapgh-loader" *ngIf="grossSaleLoader">
              <span class="loader"></span>
            </div>
            <div class="d-flex justify-content-between px-2">
              <div class="fw-600 font-size-16 text-dark-black">
                {{report.item_text}}<img src="assets/images/info-icon.svg" ngbTooltip="You see, I show up on click!"
                  class="vertical-align-super" />
              </div>
              <div class="text-end">
                <div class="d-flex">
                  <span class="f-12 me-2" [ngClass]="
                      checkNegative(grossSaleDataTotal.percentage)
                        ? 'danger-badge '
                        : 'sucess-badge'
                    ">
                    {{
                    checkNegative(grossSaleDataTotal.percentage)
                    ? grossSaleDataTotal.percentage
                    : showPlusData(grossSaleDataTotal.percentage)
                    }}%</span>
                  <span class="fw-600 font-size-16 text-dark-black">{{ currency }}
                    {{ grossSaleDataTotal.value1 | number: "1.2-2" }}</span>
                </div>
                <div class="font-size-12 fw-bold text-dark-black">
                  {{ currency }} {{ grossSaleDataTotal.value2 | number: "1.2-2" }}
                </div>
              </div>
            </div>
            <div id="charttest">
              <apx-chart class="apex-charts" dir="ltr" [series]="grossSaleData.series" [chart]="grossSaleData.chart"
                [dataLabels]="grossSaleData.dataLabels" [stroke]="grossSaleData.stroke" [colors]="grossSaleData.colors"
                [xaxis]="grossSaleData.xaxis" [grid]="grossSaleData.grid" [tooltip]="grossSaleData.tooltip"
                [plotOptions]="grossSaleData.plotOptions" [fill]="grossSaleData.fill" [markers]="grossSaleData.markers"
                [legend]="grossSaleData.legend" [yaxis]="grossSaleData.yaxis" [tooltip]="grossSaleData.tooltip">
              </apx-chart>
            </div>
          </div>
        </div>
      </ng-container> -->
    </div>
    <div class="row allchart-dashboard-RTL">
      <!-- <app-overall-reports></app-overall-reports> -->
      <div
        class="col-xl-4 col-lg-6 col-md-12 col-12 card-box"
        *ngIf="isActive('Gross Sales' | translate | async)"
      >
        <div class="charts-box ps-relative">
          <div class="grapgh-loader" *ngIf="grossSaleLoader == true">
            <span class="loader"></span>
          </div>
          <div class="d-flex justify-content-between px-2 allchart-dashboard-RTL-details">
            <div class="fw-600 font-size-16 text-dark-black d-flex gap-2">
             {{ "Gross Sales" | translate | async }}
              <i
                class="f-10 fas fa-info-circle vertical-align-super"
                [ngbPopover]="'It is not calculating/adding tax with Gross Sales = Net Sales + Discounts + service - Taxes.' | translate | async"
                triggers="mouseenter:mouseleave"
                [popoverTitle]="'Gross Sales' | translate | async"
                placement="right"
              ></i>
              <span (click)="openGrossGraph()" class="pe-13 fas fa-cog"></span>
            </div>
            <div class="text-end">
              <div class="d-flex card-text">
                <span
                  class="f-12 me-2"
                  [ngClass]="
                    checkNegative(grossSaleDataTotal.percentage)
                      ? 'danger-badge '
                      : checkZeroInc(grossSaleDataTotal.percentage)
                      ? 'zero-badge'
                      : 'sucess-badge'
                  "
                >
                  {{
                    checkNegative(grossSaleDataTotal.percentage)
                      ? grossSaleDataTotal.percentage
                      : showPlusData(grossSaleDataTotal.percentage)
                  }}%</span
                >
                <span class="fw-600 font-size-16 text-dark-black"
                  >{{ currency }}{{ grossSaleDataTotal.value1 | number : "1.2-2" }}</span
                >
              </div>
              <div class="font-size-12 fw-bold text-green-black">
                {{ currency }}{{ grossSaleDataTotal.value2 | number : "1.2-2" }}
              </div>
            </div>
          </div>
          <div id="charttest">
            <!-- <apx-chart [series]="chartOptions2.series" [chart]="chartOptions2.chart" [xaxis]="chartOptions2.xaxis"
              [dataLabels]="chartOptions2.dataLabels" [grid]="chartOptions2.grid" [stroke]="chartOptions2.stroke"
              [title]="chartOptions2.title"></apx-chart> -->
            <apx-chart
              *ngIf="selectedGrossGraph == 'line' && grossSaleLoader == true"
              class="apex-charts"
              dir="ltr"
              [series]="grossSaleData.series"
              [chart]="grossSaleData.chart"
              [dataLabels]="grossSaleData.dataLabels"
              [stroke]="grossSaleData.stroke"
              [colors]="grossSaleData.colors"
              [xaxis]="grossSaleData.xaxis"
              [grid]="grossSaleData.grid"
              [tooltip]="grossSaleData.tooltip"
              [plotOptions]="grossSaleData.plotOptions"
              [fill]="grossSaleData.fill"
              [markers]="grossSaleData.markers"
              [legend]="grossSaleData.legend"
              [yaxis]="grossSaleData.yaxis"
              [tooltip]="grossSaleData.tooltip"
            >
            </apx-chart>
            <apx-chart
              *ngIf="selectedGrossGraph == 'line' && grossSaleLoader == false"
              class="apex-charts"
              dir="ltr"
              [series]="grossSaleData.series"
              [chart]="grossSaleData.chart"
              [dataLabels]="grossSaleData.dataLabels"
              [stroke]="grossSaleData.stroke"
              [colors]="grossSaleData.colors"
              [xaxis]="grossSaleData.xaxis"
              [grid]="grossSaleData.grid"
              [tooltip]="grossSaleData.tooltip"
              [plotOptions]="grossSaleData.plotOptions"
              [fill]="grossSaleData.fill"
              [markers]="grossSaleData.markers"
              [legend]="grossSaleData.legend"
              [yaxis]="grossSaleData.yaxis"
              [tooltip]="grossSaleData.tooltip"
            >
            </apx-chart>
            <apx-chart
              *ngIf="selectedGrossGraph == 'area'"
              class="apex-charts"
              dir="ltr"
              [series]="grossSaleData.series"
              [chart]="chartTypeArea.chart"
              [dataLabels]="grossSaleData.dataLabels"
              [stroke]="chartTypeArea.stroke"
              [colors]="grossSaleData.colors"
              [xaxis]="grossSaleData.xaxis"
              [grid]="grossSaleData.grid"
              [tooltip]="grossSaleData.tooltip"
              [plotOptions]="grossSaleData.plotOptions"
              [fill]="grossSaleData.fill"
              [markers]="grossSaleData.markers"
              [legend]="grossSaleData.legend"
              [yaxis]="grossSaleData.yaxis"
              [tooltip]="grossSaleData.tooltip"
            ></apx-chart>
            <apx-chart
              *ngIf="selectedGrossGraph == 'bar'"
              class="apex-charts"
              dir="ltr"
              [series]="grossSaleData.series"
              [chart]="chartTypeBar.chart"
              [dataLabels]="grossSaleData.dataLabels"
              [stroke]="grossSaleData.stroke"
              [colors]="grossSaleData.colors"
              [xaxis]="grossSaleData.xaxis"
              [grid]="grossSaleData.grid"
              [tooltip]="grossSaleData.tooltip"
              [plotOptions]="grossSaleData.plotOptions"
              [fill]="grossSaleData.fill"
              [markers]="grossSaleData.markers"
              [legend]="grossSaleData.legend"
              [yaxis]="grossSaleData.yaxis"
              [tooltip]="grossSaleData.tooltip"
            ></apx-chart>
            <apx-chart
              *ngIf="selectedGrossGraph == 'column'"
              class="apex-charts"
              dir="ltr"
              [series]="grossSaleData.series"
              [chart]="chartTypeColumn.chart"
              [dataLabels]="grossSaleData.dataLabels"
              [stroke]="chartTypeColumn.stroke"
              [colors]="grossSaleData.colors"
              [xaxis]="grossSaleData.xaxis"
              [grid]="grossSaleData.grid"
              [tooltip]="grossSaleData.tooltip"
              [plotOptions]="chartTypeColumn.plotOptions"
              [fill]="chartTypeColumn.fill"
              [markers]="grossSaleData.markers"
              [legend]="grossSaleData.legend"
              [yaxis]="grossSaleData.yaxis"
              [tooltip]="grossSaleData.tooltip"
            ></apx-chart>
          </div>
        </div>
      </div>
      <div
        class="col-xl-4 col-lg-6 col-md-12 col-12 card-box"
        *ngIf="isActive('Net Sales'| translate | async)"
      >
        <div class="charts-box ps-relative">
          <div class="grapgh-loader" *ngIf="netSaleLoader">
            <span class="loader"></span>
          </div>
          <div class="d-flex justify-content-between px-2">
            <div class="fw-600 font-size-16 text-dark-black">
              {{ "Net Sales" | translate | async }}
              <i
                class="f-10 fas fa-info-circle vertical-align-super"
                [ngbPopover]="'Net sales is the total value of sales after all deductions (Net Sales = Gross Sales - Refunds - Taxes - Discounts - Delivery Fees)' | translate | async"
                triggers="mouseenter:mouseleave"
                [popoverTitle]="'Net Sales' | translate | async"
                placement="right"
              ></i>
            </div>
            <div class="text-end">
              <div class="d-flex card-text">
                <span
                  class="f-12 me-2"
                  [ngClass]="
                    checkNegative(netSaleDataTotal.percentage)
                      ? 'danger-badge'
                      : checkZeroInc(netSaleDataTotal.percentage)
                      ? 'zero-badge'
                      : 'sucess-badge'
                  "
                >
                  {{
                    checkNegative(netSaleDataTotal.percentage)
                      ? netSaleDataTotal.percentage
                      : showPlusData(netSaleDataTotal.percentage)
                  }}%</span
                >
                <span class="fw-600 font-size-16 text-dark-black"
                  >{{ currency }}{{ netSaleDataTotal.value1 | number : "1.2-2" }}</span
                >
              </div>
              <div class="font-size-12 fw-bold text-green-black">
                {{ currency }}{{ netSaleDataTotal.value2 | number : "1.2-2" }}
              </div>
            </div>
          </div>
          <div id="charttest">
            <!-- <apx-chart [series]="chartOptions2.series" [chart]="chartOptions2.chart" [xaxis]="chartOptions2.xaxis"
              [dataLabels]="chartOptions2.dataLabels" [grid]="chartOptions2.grid" [stroke]="chartOptions2.stroke"
              [title]="chartOptions2.title"></apx-chart> -->
            <apx-chart
              class="apex-charts"
              dir="ltr"
              [series]="netSaleData.series"
              [chart]="netSaleData.chart"
              [dataLabels]="netSaleData.dataLabels"
              [stroke]="netSaleData.stroke"
              [colors]="netSaleData.colors"
              [xaxis]="netSaleData.xaxis"
              [grid]="netSaleData.grid"
              [tooltip]="netSaleData.tooltip"
              [plotOptions]="netSaleData.plotOptions"
              [fill]="netSaleData.fill"
              [markers]="netSaleData.markers"
              [legend]="netSaleData.legend"
              [yaxis]="netSaleData.yaxis"
              [tooltip]="netSaleData.tooltip"
            ></apx-chart>
          </div>
        </div>
      </div>
      <div
        class="col-xl-4 col-lg-6 col-md-12 col-12 card-box"
        *ngIf="isActive('Total Orders' | translate | async)"
      >
        <div class="charts-box ps-relative">
          <div class="grapgh-loader" *ngIf="totalSaleLoader">
            <span class="loader"></span>
          </div>
          <div class="d-flex justify-content-between px-2">
            <div class="fw-600 font-size-16 text-dark-black">
              {{ "Total Orders" | translate | async }}
              <i
                class="f-10 fas fa-info-circle vertical-align-super"
                [ngbPopover]="'Number of all orders placed during daily hours of operation, these could be paid or unpaid orders.' | translate | async"
                triggers="mouseenter:mouseleave"
                [popoverTitle]="'Total Orders' | translate | async"
                placement="right"
              ></i>
            </div>
            <div class="text-end">
              <div class="d-flex card-text">
                <span
                  class="f-12 me-2"
                  [ngClass]="
                    checkNegative(totalSaleDataTotal.percentage)
                      ? 'danger-badge '
                      : checkZeroInc(totalSaleDataTotal.percentage)
                      ? 'zero-badge'
                      : 'sucess-badge'
                  "
                >
                  {{
                    checkNegative(totalSaleDataTotal.percentage)
                      ? totalSaleDataTotal.percentage
                      : showPlusData(totalSaleDataTotal.percentage)
                  }}%</span
                >
                <span class="fw-600 font-size-16 text-dark-black">{{
                  totalSaleDataTotal.value1
                }}</span>
              </div>
              <div class="font-size-12 fw-bold text-green-black">
                {{ totalSaleDataTotal.value2 }}
              </div>
            </div>
          </div>
          <div id="charttest">
            <!-- <apx-chart [series]="chartOptions2.series" [chart]="chartOptions2.chart" [xaxis]="chartOptions2.xaxis"
              [dataLabels]="chartOptions2.dataLabels" [grid]="chartOptions2.grid" [stroke]="chartOptions2.stroke"
              [title]="chartOptions2.title"></apx-chart> -->
            <apx-chart
              class="apex-charts"
              dir="ltr"
              [series]="totalSaleData.series"
              [chart]="totalSaleData.chart"
              [dataLabels]="totalSaleData.dataLabels"
              [stroke]="totalSaleData.stroke"
              [colors]="totalSaleData.colors"
              [xaxis]="totalSaleData.xaxis"
              [grid]="totalSaleData.grid"
              [tooltip]="totalSaleData.tooltip"
              [plotOptions]="totalSaleData.plotOptions"
              [fill]="totalSaleData.fill"
              [markers]="totalSaleData.markers"
              [legend]="totalSaleData.legend"
              [yaxis]="totalSaleData.yaxis"
              [tooltip]="totalSaleData.tooltip"
            >
            </apx-chart>
          </div>
        </div>
      </div>
      <div
        class="col-xl-4 col-lg-6 col-md-12 col-12 card-box"
        *ngIf="isActive('Total Transactions' | translate | async)"
      >
        <div class="charts-box ps-relative">
          <div class="grapgh-loader" *ngIf="totalTransactionLoader">
            <span class="loader"></span>
          </div>
          <div class="d-flex justify-content-between px-2">
            <div class="fw-600 font-size-16 text-dark-black">
              {{ "Total Transactions" | translate | async }}
              <i
                class="f-10 fas fa-info-circle vertical-align-super"
                [ngbPopover]="'Number of all orders generated during daily hours of operation with a payment associated (Accounts for Paid and Refunded Transactions)' | translate | async"
                triggers="mouseenter:mouseleave"
                [popoverTitle]="'Total Transactions' | translate | async"
                placement="right"
              ></i>
            </div>
            <div class="text-end">
              <div class="d-flex card-text">
                <span
                  class="f-12 me-2"
                  [ngClass]="
                    checkNegative(totalTransactionDataTotal.percentage)
                      ? 'danger-badge'
                      : checkZeroInc(totalTransactionDataTotal.percentage)
                      ? 'zero-badge'
                      : 'sucess-badge'
                  "
                >
                  {{
                    checkNegative(totalTransactionDataTotal.percentage)
                      ? totalTransactionDataTotal.percentage
                      : showPlusData(totalTransactionDataTotal.percentage)
                  }}%</span
                >
                <span class="fw-600 font-size-16 text-dark-black">{{
                  totalTransactionDataTotal.value1
                }}</span>
              </div>
              <div class="font-size-12 fw-bold text-green-black">
                {{ totalTransactionDataTotal.value2 }}
              </div>
            </div>
          </div>
          <div id="charttest">
            <!-- <apx-chart [series]="chartOptions2.series" [chart]="chartOptions2.chart" [xaxis]="chartOptions2.xaxis"
              [dataLabels]="chartOptions2.dataLabels" [grid]="chartOptions2.grid" [stroke]="chartOptions2.stroke"
              [title]="chartOptions2.title"></apx-chart> -->
            <apx-chart
              class="apex-charts"
              dir="ltr"
              [series]="totalTransactionData.series"
              [chart]="totalTransactionData.chart"
              [dataLabels]="totalTransactionData.dataLabels"
              [stroke]="totalTransactionData.stroke"
              [colors]="totalTransactionData.colors"
              [xaxis]="totalTransactionData.xaxis"
              [grid]="totalTransactionData.grid"
              [tooltip]="totalTransactionData.tooltip"
              [plotOptions]="totalTransactionData.plotOptions"
              [fill]="totalTransactionData.fill"
              [markers]="totalTransactionData.markers"
              [legend]="totalTransactionData.legend"
              [yaxis]="totalTransactionData.yaxis"
              [tooltip]="totalTransactionData.tooltip"
            ></apx-chart>
          </div>
        </div>
      </div>
      <div
        class="col-xl-4 col-lg-6 col-md-12 col-12 card-box"
        *ngIf="isActive('Total Refunds' | translate | async)"
      >
        <div class="charts-box ps-relative">
          <div class="grapgh-loader" *ngIf="totalRefundsLoader">
            <span class="loader"></span>
          </div>
          <div class="d-flex justify-content-between px-2">
            <div class="fw-600 font-size-16 text-dark-black">
              {{ "Total Refunds" | translate | async }}
              <i
                class="f-10 fas fa-info-circle vertical-align-super"
                [ngbPopover]="'Total value of all orders refunded during daily hours of operation' | translate | async"
                triggers="mouseenter:mouseleave"
                [popoverTitle]="'Total Refunds' | translate | async"
                placement="right"
              ></i>
            </div>
            <div class="text-end">
              <div class="d-flex card-text">
                <span
                  class="f-12 me-2"
                  [ngClass]="
                    checkNegative(totalRefundsDataTotal.percentage)
                      ? 'danger-badge '
                      : checkZeroInc(totalRefundsDataTotal.percentage)
                      ? 'zero-badge'
                      : 'sucess-badge'
                  "
                >
                  {{
                    checkNegative(totalRefundsDataTotal.percentage)
                      ? totalRefundsDataTotal.percentage
                      : showPlusData(totalRefundsDataTotal.percentage)
                  }}%</span
                >
                <span class="fw-600 font-size-16 text-dark-black"
                  >{{ currency }}{{ totalRefundsDataTotal.value1 | number : "1.2-2" }}</span
                >
              </div>
              <div class="font-size-12 fw-bold text-green-black">
                {{ currency }}{{ totalRefundsDataTotal.value2 | number : "1.2-2" }}
              </div>
            </div>
          </div>
          <div id="charttest">
            <!-- <apx-chart [series]="chartOptions2.series" [chart]="chartOptions2.chart" [xaxis]="chartOptions2.xaxis"
              [dataLabels]="chartOptions2.dataLabels" [grid]="chartOptions2.grid" [stroke]="chartOptions2.stroke"
              [title]="chartOptions2.title"></apx-chart> -->
            <apx-chart
              class="apex-charts"
              dir="ltr"
              [series]="totalRefundsData.series"
              [chart]="totalRefundsData.chart"
              [dataLabels]="totalRefundsData.dataLabels"
              [stroke]="totalRefundsData.stroke"
              [colors]="totalRefundsData.colors"
              [xaxis]="totalRefundsData.xaxis"
              [grid]="totalRefundsData.grid"
              [tooltip]="totalRefundsData.tooltip"
              [plotOptions]="totalRefundsData.plotOptions"
              [fill]="totalRefundsData.fill"
              [markers]="totalRefundsData.markers"
              [legend]="totalRefundsData.legend"
              [yaxis]="totalRefundsData.yaxis"
              [tooltip]="totalRefundsData.tooltip"
            ></apx-chart>
          </div>
        </div>
      </div>
      <div
        class="col-xl-4 col-lg-6 col-md-12 col-12 card-box"
        *ngIf="isActive('Total Discounts' | translate | async)"
      >
        <div class="charts-box ps-relative">
          <div class="grapgh-loader" *ngIf="totalDiscountLoader">
            <span class="loader"></span>
          </div>
          <div class="d-flex justify-content-between px-2">
            <div class="fw-600 font-size-16 text-dark-black">
              {{ "Total Discounts" | translate | async }}
              <i
                class="f-10 fas fa-info-circle vertical-align-super"
                [ngbPopover]="'Total value of all discounts given during the daily hours of operation' | translate | async"
                triggers="mouseenter:mouseleave"
                [popoverTitle]="'Total Discounts' | translate | async"
                placement="right"
              ></i>
            </div>
            <div class="text-end">
              <div class="d-flex card-text">
                <span
                  class="f-12 me-2"
                  [ngClass]="
                    checkNegative(totalDiscountDataTotal.percentage)
                      ? 'danger-badge'
                      : checkZeroInc(totalDiscountDataTotal.percentage)
                      ? 'zero-badge'
                      : 'sucess-badge'
                  "
                >
                  {{
                    checkNegative(totalDiscountDataTotal.percentage)
                      ? totalDiscountDataTotal.percentage
                      : showPlusData(totalDiscountDataTotal.percentage)
                  }}%</span
                >
                <span class="fw-600 font-size-16 text-dark-black"
                  >{{ currency }}{{ totalDiscountDataTotal.value1 | number : "1.2-2" }}</span
                >
              </div>
              <div class="font-size-12 fw-bold text-green-black">
                {{ currency }}{{ totalDiscountDataTotal.value2 | number : "1.2-2" }}
              </div>
            </div>
          </div>
          <div id="charttest">
            <!-- <apx-chart [series]="chartOptions2.series" [chart]="chartOptions2.chart" [xaxis]="chartOptions2.xaxis"
              [dataLabels]="chartOptions2.dataLabels" [grid]="chartOptions2.grid" [stroke]="chartOptions2.stroke"
              [title]="chartOptions2.title"></apx-chart> -->
            <apx-chart
              class="apex-charts"
              dir="ltr"
              [series]="totalDiscountData.series"
              [chart]="totalDiscountData.chart"
              [dataLabels]="totalDiscountData.dataLabels"
              [stroke]="totalDiscountData.stroke"
              [colors]="totalDiscountData.colors"
              [xaxis]="totalDiscountData.xaxis"
              [grid]="totalDiscountData.grid"
              [tooltip]="totalDiscountData.tooltip"
              [plotOptions]="totalDiscountData.plotOptions"
              [fill]="totalDiscountData.fill"
              [markers]="totalDiscountData.markers"
              [legend]="totalDiscountData.legend"
              [yaxis]="totalDiscountData.yaxis"
              [tooltip]="totalDiscountData.tooltip"
            ></apx-chart>
          </div>
        </div>
      </div>
      <div
        class="col-xl-4 col-lg-6 col-md-12 col-12 card-box"
        *ngIf="isActive(taxText | translate | async)"
      >
        <div class="charts-box ps-relative">
          <div class="grapgh-loader" *ngIf="totalTaxesLoader">
            <span class="loader"></span>
          </div>
          <div class="d-flex justify-content-between px-2">
            <div class="fw-600 font-size-16 text-dark-black">
              {{ "Total" | translate | async }} {{ (taxAliasValue ? taxAliasValue : 'Taxes') | translate | async }}
              <i
                class="f-10 fas fa-info-circle vertical-align-super"
                [ngbPopover]="taxAliasPopover | translate | async"
                triggers="mouseenter:mouseleave"
                [popoverTitle]="taxAliasPopoverTitle | translate | async"
                placement="right"
              ></i>
            </div>
            <div class="text-end">
              <div class="d-flex card-text">
                <span
                  class="f-12 me-2"
                  [ngClass]="
                    checkNegative(totalTaxesDataTotal.percentage)
                      ? 'danger-badge'
                      : checkZeroInc(totalTaxesDataTotal.percentage)
                      ? 'zero-badge'
                      : 'sucess-badge'
                  "
                >
                  {{
                    checkNegative(totalTaxesDataTotal.percentage)
                      ? totalTaxesDataTotal.percentage
                      : showPlusData(totalTaxesDataTotal.percentage)
                  }}%</span
                >
                <span class="fw-600 font-size-16 text-dark-black"
                  >{{ currency }}{{ totalTaxesDataTotal.value1 | number : "1.2-2" }}</span
                >
              </div>
              <div class="font-size-12 fw-bold text-green-black">
                {{ currency }}{{ totalTaxesDataTotal.value2 | number : "1.2-2" }}
              </div>
            </div>
          </div>
          <div id="charttest">
            <!-- <apx-chart [series]="chartOptions2.series" [chart]="chartOptions2.chart" [xaxis]="chartOptions2.xaxis"
              [dataLabels]="chartOptions2.dataLabels" [grid]="chartOptions2.grid" [stroke]="chartOptions2.stroke"
              [title]="chartOptions2.title"></apx-chart> -->
            <apx-chart
              class="apex-charts"
              dir="ltr"
              [series]="totalTaxesData.series"
              [chart]="totalTaxesData.chart"
              [dataLabels]="totalTaxesData.dataLabels"
              [stroke]="totalTaxesData.stroke"
              [colors]="totalTaxesData.colors"
              [xaxis]="totalTaxesData.xaxis"
              [grid]="totalTaxesData.grid"
              [tooltip]="totalTaxesData.tooltip"
              [plotOptions]="totalTaxesData.plotOptions"
              [fill]="totalTaxesData.fill"
              [markers]="totalTaxesData.markers"
              [legend]="totalTaxesData.legend"
              [yaxis]="totalTaxesData.yaxis"
              [tooltip]="totalTaxesData.tooltip"
            >
            </apx-chart>
          </div>
        </div>
      </div>
      <div
        class="col-xl-4 col-lg-6 col-md-12 col-12 card-box"
        *ngIf="isActive('Total Tips' | translate | async)"
      >
        <div class="charts-box ps-relative">
          <div class="grapgh-loader" *ngIf="totalTipsLoader">
            <span class="loader"></span>
          </div>
          <div class="d-flex justify-content-between px-2">
            <div class="fw-600 font-size-16">
              {{ "Total Tips" | translate | async }}
              <i
                class="f-10 fas fa-info-circle vertical-align-super"
                [ngbPopover]="'Total value of all tips from paid orders during daily hours of operation' | translate | async"
                triggers="mouseenter:mouseleave"
                [popoverTitle]="'Total Tips' | translate | async"
                placement="right"
              ></i>
            </div>
            <div class="text-end">
              <div class="d-flex card-text">
                <span
                  class="f-12 me-2"
                  [ngClass]="
                    checkNegative(totalTipsDataTotal.percentage)
                      ? 'danger-badge'
                      : checkZeroInc(totalTipsDataTotal.percentage)
                      ? 'zero-badge'
                      : 'sucess-badge'
                  "
                >
                  {{
                    checkNegative(totalTipsDataTotal.percentage)
                      ? totalTipsDataTotal.percentage
                      : showPlusData(totalTipsDataTotal.percentage)
                  }}%</span
                >
                <span class="fw-600 font-size-16 text-dark-black"
                  >{{ currency }}{{ totalTipsDataTotal.value1 | number : "1.2-2" }}</span
                >
              </div>
              <div class="font-size-12 fw-bold text-green-black">
                {{ currency }}{{ totalTipsDataTotal.value2 | number : "1.2-2" }}
              </div>
            </div>
          </div>
          <div id="charttest">
            <!-- <apx-chart [series]="chartOptions2.series" [chart]="chartOptions2.chart" [xaxis]="chartOptions2.xaxis"
              [dataLabels]="chartOptions2.dataLabels" [grid]="chartOptions2.grid" [stroke]="chartOptions2.stroke"
              [title]="chartOptions2.title"></apx-chart> -->
            <apx-chart
              class="apex-charts"
              dir="ltr"
              [series]="totalTipsData.series"
              [chart]="totalTipsData.chart"
              [dataLabels]="totalTipsData.dataLabels"
              [stroke]="totalTipsData.stroke"
              [colors]="totalTipsData.colors"
              [xaxis]="totalTipsData.xaxis"
              [grid]="totalTipsData.grid"
              [tooltip]="totalTipsData.tooltip"
              [plotOptions]="totalTipsData.plotOptions"
              [fill]="totalTipsData.fill"
              [markers]="totalTipsData.markers"
              [legend]="totalTipsData.legend"
              [yaxis]="totalTipsData.yaxis"
              [tooltip]="totalTipsData.tooltip"
            >
            </apx-chart>
          </div>
        </div>
      </div>
      <div
        class="col-xl-4 col-lg-6 col-md-12 col-12 card-box"
        *ngIf="isActive('Total Delivery Fees' | translate | async)"
      >
        <div class="charts-box ps-relative">
          <div class="grapgh-loader" *ngIf="totalDeliveryTipsLoader">
            <span class="loader"></span>
          </div>
          <div class="d-flex justify-content-between px-2">
            <div class="fw-600 font-size-16 text-dark-black">
              {{ "Total Delivery Fees" | translate | async }}
              <i
                class="f-10 fas fa-info-circle vertical-align-super"
                [ngbPopover]="'Total value of all delivery fees from paid orders during daily hours of operation' | translate | async"
                triggers="mouseenter:mouseleave"
                [popoverTitle]="'Total Delivery\'s Fees' | translate | async"
                placement="right"
              ></i>
            </div>
            <div class="text-end">
              <div class="d-flex">
                <span
                  class="f-12 me-2"
                  [ngClass]="
                    checkNegative(totalDeliveryTipsDataTotal.percentage)
                      ? 'danger-badge'
                      : checkZeroInc(totalDeliveryTipsDataTotal.percentage)
                      ? 'zero-badge'
                      : 'sucess-badge'
                  "
                >
                  {{
                    checkNegative(totalDeliveryTipsDataTotal.percentage)
                      ? totalDeliveryTipsDataTotal.percentage
                      : showPlusData(totalDeliveryTipsDataTotal.percentage)
                  }}%</span
                >
                <span class="fw-600 font-size-16 text-dark-black"
                  >{{ currency }}{{
                    totalDeliveryTipsDataTotal.value1 | number : "1.2-2"
                  }}</span
                >
              </div>
              <div class="font-size-12 text-green-black fw-bold">
                {{ currency }}{{ totalDeliveryTipsDataTotal.value2 | number : "1.2-2" }}
              </div>
            </div>
          </div>
          <div id="charttest">
            <!-- <apx-chart [series]="chartOptions2.series" [chart]="chartOptions2.chart" [xaxis]="chartOptions2.xaxis"
              [dataLabels]="chartOptions2.dataLabels" [grid]="chartOptions2.grid" [stroke]="chartOptions2.stroke"
              [title]="chartOptions2.title"></apx-chart> -->
            <apx-chart
              class="apex-charts"
              dir="ltr"
              [series]="totalDeliveryTipsData.series"
              [chart]="totalDeliveryTipsData.chart"
              [dataLabels]="totalDeliveryTipsData.dataLabels"
              [stroke]="totalDeliveryTipsData.stroke"
              [colors]="totalDeliveryTipsData.colors"
              [xaxis]="totalDeliveryTipsData.xaxis"
              [grid]="totalDeliveryTipsData.grid"
              [tooltip]="totalDeliveryTipsData.tooltip"
              [plotOptions]="totalDeliveryTipsData.plotOptions"
              [fill]="totalDeliveryTipsData.fill"
              [markers]="totalDeliveryTipsData.markers"
              [legend]="totalDeliveryTipsData.legend"
              [yaxis]="totalDeliveryTipsData.yaxis"
              [tooltip]="totalDeliveryTipsData.tooltip"
            ></apx-chart>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>


<!-- see all links Section  -->
<!-- see all links Section  -->
<!-- <div class="card br-0 dashboard-main" style="margin-bottom: 20px">
  <div class="card-body report-RTL-overview">
    <div class="row allchart-dashboard-RTL">
      <app-all-links-demo></app-all-links-demo>
    </div>
  </div>
</div> -->
<!-- see all links Section  -->
<!-- see all links Section  -->

<ng-template #graphModalContent role="document" let-modal>
  <div class="modal-header border-0">
    <h5 class="modal-title fw-600">{{ "Customize Gross Sales Graph" | translate | async }}</h5>
    <img
      src="assets\images\closeIcon.svg"
      class=""
      (click)="modal.dismiss('Cross click')"
    />
  </div>
  <div class="modal-body">
    <div class="row">
      <div class="col-6">
        <button
          class="btn graph"
          [ngClass]="{ active: false }"
          (click)="setGrossGraph('line')"
        >
          <apx-chart
            class="apex-charts"
            dir="ltr"
            [series]="grossSaleData.series"
            [chart]="grossSaleData.chart"
            [dataLabels]="grossSaleData.dataLabels"
            [stroke]="grossSaleData.stroke"
            [colors]="grossSaleData.colors"
            [xaxis]="grossSaleData.xaxis"
            [grid]="grossSaleData.grid"
            [tooltip]="grossSaleData.tooltip"
            [plotOptions]="grossSaleData.plotOptions"
            [fill]="grossSaleData.fill"
            [markers]="grossSaleData.markers"
            [legend]="grossSaleData.legend"
            [yaxis]="grossSaleData.yaxis"
            [tooltip]="grossSaleData.tooltip"
          ></apx-chart>
        </button>
      </div>
      <div class="col-6">
        <button
          class="btn graph"
          [ngClass]="{ active: selectedGrossGraph === 'area' }"
          (click)="setGrossGraph('area')"
        >
          <apx-chart
            class="apex-charts"
            dir="ltr"
            [series]="grossSaleData.series"
            [chart]="chartTypeArea.chart"
            [dataLabels]="grossSaleData.dataLabels"
            [stroke]="chartTypeArea.stroke"
            [colors]="grossSaleData.colors"
            [xaxis]="grossSaleData.xaxis"
            [grid]="grossSaleData.grid"
            [tooltip]="grossSaleData.tooltip"
            [plotOptions]="grossSaleData.plotOptions"
            [fill]="grossSaleData.fill"
            [markers]="grossSaleData.markers"
            [legend]="grossSaleData.legend"
            [yaxis]="grossSaleData.yaxis"
            [tooltip]="grossSaleData.tooltip"
          ></apx-chart>
        </button>
      </div>
      <div class="col-6">
        <button
          class="btn graph"
          [ngClass]="{ active: selectedGrossGraph === 'bar' }"
          (click)="setGrossGraph('bar')"
        >
          <apx-chart
            class="apex-charts"
            dir="ltr"
            [series]="grossSaleData.series"
            [chart]="chartTypeBar.chart"
            [dataLabels]="grossSaleData.dataLabels"
            [stroke]="grossSaleData.stroke"
            [colors]="grossSaleData.colors"
            [xaxis]="grossSaleData.xaxis"
            [grid]="grossSaleData.grid"
            [tooltip]="grossSaleData.tooltip"
            [plotOptions]="grossSaleData.plotOptions"
            [fill]="grossSaleData.fill"
            [markers]="grossSaleData.markers"
            [legend]="grossSaleData.legend"
            [yaxis]="grossSaleData.yaxis"
            [tooltip]="grossSaleData.tooltip"
          ></apx-chart>
        </button>
      </div>
      <div class="col-6">
        <button
          class="btn graph"
          [ngClass]="{ active: selectedGrossGraph === 'column' }"
          (click)="setGrossGraph('column')"
        >
          <apx-chart
            class="apex-charts"
            dir="ltr"
            [series]="grossSaleData.series"
            [chart]="chartTypeColumn.chart"
            [dataLabels]="grossSaleData.dataLabels"
            [stroke]="chartTypeColumn.stroke"
            [colors]="grossSaleData.colors"
            [xaxis]="grossSaleData.xaxis"
            [grid]="grossSaleData.grid"
            [tooltip]="grossSaleData.tooltip"
            [plotOptions]="chartTypeColumn.plotOptions"
            [fill]="chartTypeColumn.fill"
            [markers]="grossSaleData.markers"
            [legend]="grossSaleData.legend"
            [yaxis]="grossSaleData.yaxis"
            [tooltip]="grossSaleData.tooltip"
          ></apx-chart>
        </button>
      </div>
    </div>
  </div>
  <!-- <div class="modal-footer border-0">
    <button type="button" class="btn btn-dark w-100" *ngIf="true"
      [disabled]="false">
      <ng-container *ngIf="true"> Save </ng-container>
      <ng-container *ngIf="false">
        <span class="spinner-grow spinner-grow-sm" role="status" aria-hidden="true"></span>
        <span class="pl-2">&nbsp;&nbsp;Please wait...</span>
      </ng-container>
    </button>
  </div> -->
</ng-template>
